import React, { useEffect, useState } from 'react';
import Logger from '../utils/Logger';
import SierraInitializer from './SierraInitializer';
import { isChatOpen } from './sierraChatCookie';

const SierraChatLauncher = () => {
	const [chatOpen, setChatOpen] = useState(isChatOpen());
	const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 780);

	useEffect(() => {
		// Initialize SDK on mount - onLoad callback handles reopening if needed
		SierraInitializer.initialize();
	}, []);

	useEffect(() => {
		// Handle resize for responsive positioning
		const handleResize = () => {
			setIsWideScreen(window.innerWidth >= 780);
		};

		// Poll for cookie changes (cookies don't have a native change event)
		// This allows the launcher to appear/disappear when chat state changes
		const interval = setInterval(() => {
			const isOpen = isChatOpen();
			if (isOpen !== chatOpen) {
				setChatOpen(isOpen);
			}
		}, 500);

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
			clearInterval(interval);
		};
	}, [chatOpen]);

	const handleClick = () => {
		SierraInitializer.openChat(
			() => {
				Logger.logToServer({
					category: 'sierra_chat',
					page: 'launcher',
					action: 'sdk_missing',
				});
			},
			null,
			window.location.hash
				.split('?')[0]
				.replace('#/', '') // Extract page from hash
		);
	};

	// Only show launcher when there IS an active chat (chatOpen === true)
	if (!chatOpen) return null;

	// Responsive bottom positioning: 16px on wide screens, 86px on mobile (to avoid nav overlap)
	const bottomPosition = isWideScreen ? '16px' : 'calc(70px + 16px)';

	return (
		<button
			type="button"
			onClick={handleClick}
			aria-label="Chat with us"
			style={{
				position: 'fixed',
				bottom: bottomPosition,
				right: '16px',
				width: '60px',
				height: '60px',
				borderRadius: '50%',
				backgroundColor: '#11003A',
				color: 'white',
				border: '1px solid #E5E7EB',
				boxShadow:
					'0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
				cursor: 'pointer',
				zIndex: 2147483647,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				outline: 'none',
			}}
		>
			{/* Chat bubble icon SVG (matches IconChatBubbleFilled from unified app) */}
			<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
				<path d="M12 2C6.48 2 2 6.48 2 12c0 1.54.36 3 .97 4.29L2 22l5.71-.97C9 21.64 10.46 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.38 0-2.68-.32-3.85-.89L4 20l.89-4.15C4.32 14.68 4 13.38 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8z" />
			</svg>
		</button>
	);
};

export default SierraChatLauncher;
